


































































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { Member, OptionGroupViewer, TopicDetails, UserProfile } from '@/models'
import GroupMemberService from '@/services/GroupMemberService'
//@ts-ignore
import _ from 'lodash'
import ModalShowProfile from '@/components/Modal/ModalShowProfile.vue'
import { handleMemberLoginStatus } from '@/helpers/Common'

@Component({ components: { ModalShowProfile } })
export default class ModalGroupMemberList extends Vue {
  @Prop({ default: 'group-member-list' }) id!: string
  @Prop() private topicDetails!: TopicDetails

  private groupId: string = this.$route.params.groupId
  page: number = 1
  private limit: number = this.$store.state.setting.setting.setting_display
    .number_item_lists
  selectedMemberList: Member[] = []
  memberList: Member[] = []
  public noAvatar = require('@/assets/images/avatar-default.png')
  public showSelected: boolean = false
  maxPage: number = 0
  searchMember: string = ''
  private debouncedSearch = _.debounce(this.handleSearchMember, 500)
  private firstMemberInList: Member = new Member()
  selectedUserId: number = -1

  memberRoleWidth = 70
  memberLastLoginWidth = 160

  isCurrentUser(id: number) {
    return id === this.$store.state.userInfo.user.info.id
  }

  getGroupMemberList(shouldSetFirstData?: boolean) {
    GroupMemberService.getAllMembersByGroupId({
      groupId: this.groupId,
      page: this.page,
      limit: this.limit,
      search: this.searchMember,
      created_first: true,
      created_by: true
    }).then(response => {
      if (response.status === 200) {
        const { data, last_page } = response.data || {}
        const mappingData = data.map((item: any) => new Member(item))
        this.memberList = [...this.memberList, ...mappingData]
        if (shouldSetFirstData) {
          this.firstMemberInList = this.memberList[0]
        }
        this.maxPage = last_page
      }
    })
  }

  @Watch('topicDetails.option_viewer', { deep: true })
  onOptionViewerChange() {
    const topicDetail = this.topicDetails
    if (topicDetail.option_viewer === OptionGroupViewer.INDIVIDUAL) {
      if (topicDetail.selected_members.length) {
        this.selectedMemberList = topicDetail.selected_members
      } else {
        this.selectedMemberList = [
          ...this.selectedMemberList,
          this.firstMemberInList
        ]
      }
    } else {
      this.resetState()
      this.getGroupMemberList(true)
    }
    this.$emit('onRetrieveSelectedMember', {
      selectedMembers: this.selectedMemberList,
      handleContent: false
    })
  }

  created() {
    this.getGroupMemberList(true)

    const currentLanguage = this.$store.state.setting.setting.setting_language
      .code

    if (currentLanguage === 'en') {
      this.memberRoleWidth = 115
      this.memberLastLoginWidth = 128
    }
  }

  get isRoleAdmin() {
    return this.$store.state.userInfo.user.group_role.role_admin
  }

  get isOnlyOneMemberSelected(): boolean {
    return this.selectedMemberList.length === 1
  }

  isMemberAlreadySelected(memberId: number) {
    return this.selectedMemberList.some(member => member.id === memberId)
  }

  getFullName(profile?: UserProfile) {
    const name = [
      profile?.first_name,
      profile?.last_name,
      String(this.$t('groups.member_list.name_suffix'))
    ].join(' ')
    return name
  }

  getUserAvatarSmall(user: any): string {
    return user && user.user_profile && user.user_profile.avatar_small
      ? user.user_profile.avatar_small
      : ''
  }

  handleLoginStatus(member: Member) {
    return handleMemberLoginStatus({
      lastLoginAt: member?.last_login_at,
      tobeLoggedOut: !!member?.to_be_logged_out,
      isCurrentUser: this.isCurrentUser(member.id)
    })
  }

  resetState() {
    this.page = 1
    this.showSelected = false
    this.searchMember = ''
    this.memberList = []
    this.selectedMemberList = []
  }

  onSearchMember() {
    this.debouncedSearch()
  }

  handleSearchMember() {
    this.page = 1
    this.memberList = []
    this.showSelected = false
    this.getGroupMemberList()
  }

  onSelectMember(event: Event, selectedMember: Member) {
    const target = event.target as HTMLInputElement

    const isCurrent = this.isCurrentUser(selectedMember.id)

    // 🔒 Prevent unchecking the current user (should always be selected)
    if (!target.checked && isCurrent) {
      target.checked = true
      return
    }

    if (target.checked) {
      if (!this.isMemberAlreadySelected(selectedMember.id)) {
        this.selectedMemberList = [...this.selectedMemberList, selectedMember]
      }
    } else {
      this.selectedMemberList = this.selectedMemberList.filter(
        member => member.id !== selectedMember.id
      )
    }
  }

  handleMemberRole(member: Member) {
    if (member.isAdmin) {
      return this.$t('groups.member_list.role_admin')
    }

    if (member.user_permissions.length !== 0) {
      return this.$t('groups.member_list.role_member_plus')
    }

    return this.$t('groups.member_list.role_member')
  }

  loadMore() {
    this.page++
    this.getGroupMemberList()
  }

  onModalClosed() {
    this.$emit('onRetrieveSelectedMember', {
      selectedMembers: this.selectedMemberList,
      handleContent: true
    })
  }

  async showMemberProfile(profile?: UserProfile) {
    this.selectedUserId = profile ? profile.user_id : -1
    this.$bvModal.show('modal-show-profile')
  }
}
